import React from "react";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import ClearIcon from "@mui/icons-material/Clear";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

import PhoneNumberService from "../utils/phone-number-services";

interface Props {
	phones: string[];
	handleClearAll?: () => void;
	handleDelete?: (phoneToDelete: string) => void;
}

const PhoneNumbersPreview = ({
	phones,
	handleClearAll,
	handleDelete,
}: Props) => {
	const { formatPhoneNumber } = PhoneNumberService;

	return (
		<Paper
			sx={{
				p: 2,
				mt: 2,
				width: "100%",
			}}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 2,
					position: "",
				}}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<CheckCircleRoundedIcon color='success' sx={{ mr: 1 }} />
					<Typography variant='body2'>
						To: <b>{phones.length} recipients</b>
					</Typography>
				</Box>
				{handleClearAll && (
					<Button
						variant='text'
						onClick={handleClearAll}
						size='small'
						startIcon={<ClearIcon />}
						sx={{ textTransform: "none" }}>
						Clear all
					</Button>
				)}
			</Box>
			<Box
				sx={{
					display: "flex",
					justifyContent: "start",
					flexWrap: "wrap",
					maxHeight: "400px",
					overflowY: "scroll",
				}}>
				{phones.map((phone, index) => (
					<Chip
						data-testid={`phone-number-chip-${index}`}
						label={formatPhoneNumber(phone)}
						onDelete={handleDelete ? () => handleDelete(phone) : undefined}
						key={phone}
						sx={{ mr: 0.5, mb: 0.5 }}
					/>
				))}
			</Box>
		</Paper>
	);
};

export default PhoneNumbersPreview;
